export default __webpack_public_path__ + "static/media/ToolBox-min.21708009.png";